module.exports = __webpack_public_path__ + "static/media/acqua.b1081fe6.jpg";